import { IonCheckbox } from '@ionic/react';
import styled from 'styled-components';
import { AllieCheckboxProps } from './Checkbox.types';

export const StyledCheckbox: any = styled(IonCheckbox)`
  --border-radius: 4px;
  --border-color: var(--allie-color-primary-60);
  --border-width: 1px;
  --size: ${(props: AllieCheckboxProps) => `${props.size}px`};
  --background-checked: var(--allie-color-primary-90);
  --border-color-checked: var(--allie-color-primary-60);

  &::part(container) {
    padding: 2px;
  }
`;
